module.exports = __webpack_public_path__ + "static/enjoy-a3e103e6e9975a02634e30be74ddc27e.jpg";